// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1a6JR","colMaxWidth":"Table_colMaxWidth__xLA6F"};